/**
 * Formats the postal line of a GPSR contact: "<postCode> <city> (<state>)".
 * The state is only appended in parentheses when it is present, so a contact
 * without a state renders exactly as before and never shows empty brackets.
 * Returns an empty string when none of the parts is present.
 */
export const formatContactLocation = ({ postCode, city, state } = {}) => {
	const place = [postCode, city]
		.map(part => (part || "").trim())
		.filter(Boolean)
		.join(" ");
	const region = (state || "").trim();

	if (!region) {
		return place;
	}
	return place ? `${place} (${region})` : region;
};
